// src/activity/dto/request/assignment/assign.dto.ts
import {
  IsUUID,
  IsOptional,
  IsDateString,
  IsArray,
  ArrayNotEmpty,
  Matches,
} from 'class-validator'

export class AssignClassDto {
  @IsUUID() activityId!: string
  @IsUUID() classId!: string
  @IsOptional() @Matches(/^\d{4}-\d{4}$/) academicYear?: string
  @IsOptional() @IsDateString() availableFrom?: string
  @IsOptional() @IsDateString() dueAt?: string
}

export class AssignUsersDto {
  @IsUUID() activityId!: string
  @IsArray()
  @ArrayNotEmpty()
  @IsUUID(undefined, { each: true })
  userIds!: string[]
  @IsOptional() @Matches(/^\d{4}-\d{4}$/) academicYear?: string
  @IsOptional() @IsDateString() availableFrom?: string
  @IsOptional() @IsDateString() dueAt?: string
}
